import React from "react";
import * as modalDataService from "./modalDataService";
import { debug } from "../../utils";
import { connect } from "react-redux";

function DomainSetField({ domainSet }) {

    const onChange = (value) => {
        modalDataService.changeDomainSet(value);
        //!value && modalDataService.unselectAllEvents();
    }

    return (
        <div className="form-group">
            <div className="oct_check">
                <label className="oct_check-label">
                    <input type="checkbox" checked={!!domainSet} onChange={() => onChange(!domainSet)} />
                    <span>Add Domain</span>
                </label>
            </div>
        </div>
    )

}

function mapStateToProps(state) {
    debug("EnableSyslogProcessingField mapStateToProps", state);
    const addDeviceModal = state.addDeviceModal;
    return {
        domainSet: addDeviceModal.domainSet || ''
    }
}

export default connect(mapStateToProps)(DomainSetField);
